// extracted by mini-css-extract-plugin
var _1 = "LoadingScreen-module__loadingIndicatorContainer--f69n8";
export { _1 as "loadingIndicatorContainer" }
